import { clsx } from 'clsx'
import { type FC, type ReactNode, useId } from 'react'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

export const DirectContactFormOrderProductsSelectionContainer: FC<{
  'data-qa-id': string
  hasError: boolean
  label: ReactNode
  onClick: () => void
  selectedValue?: ReactNode
}> = ({ 'data-qa-id': dataQaId, hasError, label, onClick, selectedValue }) => {
  const labelId = useId()
  const valueId = useId()
  const errorId = `${dataQaId}-error`

  return (
    <Button
      aria-describedby={hasError ? errorId : undefined}
      aria-haspopup="dialog"
      aria-labelledby={selectedValue ? `${labelId} ${valueId}` : labelId}
      className={clsx(
        'min-h-14 w-full rounded-full border bg-light-primary-low px-6 py-1.5 text-start',
        hasError
          ? 'border-dark-brand'
          : 'border-dark-primary-min hover:bg-light-primary-medium',
      )}
      data-qa-id={dataQaId}
      endIcon={<IconArrowRight className="-mr-2 size-6 shrink-0" />}
      onClick={onClick}
      type="button"
      variant="text"
    >
      <span className="flex min-w-0 flex-1 flex-col">
        <span
          className={clsx(
            selectedValue ? 'text-xs' : 'text-m',
            'text-dark-primary-strong',
          )}
          id={labelId}
        >
          {label}
        </span>
        <span
          className="min-w-0 truncate text-m text-dark-primary-max"
          data-qa-id={`${dataQaId}-selected-value`}
          id={valueId}
        >
          {selectedValue}
        </span>
      </span>
    </Button>
  )
}
